import { Grid } from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import TextInput from "../../../../components/TextInput";
import { authSlice } from "../../../../store/reducer/auth";
import { userSlice } from "../../../../store/reducer/user";
import { RootState } from "../../../../store";

const EnterName = () => {
    const dispatch = useDispatch();
    const { first_name, last_name } = useSelector((state: RootState) => state.user.data!);
    const firstNameError = useSelector((state: RootState) => state.auth.formErrors.first_name);
    const lastNameError = useSelector((state: RootState) => state.auth.formErrors.last_name);

    return (
        <ValidatorForm
            onSubmit={() => {
                dispatch(authSlice.actions.resetFormErrors());
                dispatch(authSlice.actions.resetError());
                dispatch(authSlice.actions.precogAutoValidateRegistrationField({
                    fields: { 'first_name': first_name, 'last_name': last_name }, 
                    next: '/register/address' 
                }));
            }}>
            <br />
            <Grid container spacing={2} className='form-container xl noexpand'>
                <Grid size={6}>
                    <TextInput
                        aria-required
                        label="First name"
                        placeholder="First name"
                        value={first_name}
                        name="first_name"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            dispatch(userSlice.actions.updateUserData({ first_name: e.target.value }));
                        }}
                        autoComplete="off"
                        error={!!firstNameError}
                        helperText={!!firstNameError ? firstNameError : ''}
                    />
                </Grid>
                <Grid size={6}>
                    <TextInput
                        aria-required
                        label="Last name"
                        placeholder="Last name"
                        value={last_name}
                        name="last_name"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            dispatch(userSlice.actions.updateUserData({ last_name: e.target.value }));
                        }}
                        autoComplete="off"
                        error={!!lastNameError}
                        helperText={!!lastNameError ? lastNameError : ''}
                    />
                </Grid>
            </Grid>
            <div className='btn-container single'>
                <CustomButton
                    variant="contained"
                    disableElevation={true}
                    label={"next"}
                    type="submit"
                    buttonSize="btn-lg"
                />
            </div>
        </ValidatorForm>
    );
};

export default EnterName;
